import { render, staticRenderFns } from "./DynamicParameters.vue?vue&type=template&id=413c23e6&scoped=true&"
import script from "./DynamicParameters.vue?vue&type=script&lang=ts&"
export * from "./DynamicParameters.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicParameters.vue?vue&type=style&index=0&id=413c23e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c23e6",
  null
  
)

export default component.exports